import React, { FC, useEffect, useState } from "react";
import { Block, Icon } from "../../../../components/Component";
import { useFieldArray, useFormContext } from "react-hook-form";
import { Button, Col, Row, Spinner } from "reactstrap";
import { Table, TableColumnsType, Tooltip } from "antd";
import { PaperClipOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router";
import Swal from "sweetalert2";
import MaterialModal from "./MaterialModal";
import BulkMaterialUpload from "./BulkMaterialUpload";
import supplierApis from "../../../../api/master/supplier";
import { nanoid } from "@reduxjs/toolkit";
import dayjs from "dayjs";

const normalize = (val: any) =>
  (val ?? "").toString().trim().replace(/\s+/g, "").toLowerCase();

const TenderForMaterialMain: React.FC<any> = ({ prev, next }) => {
  const [sm, setSm] = useState(false);
  const [screenSize, setScreenSize] = useState(0);
  const [mobileView, setMobileView] = useState(false);
  const { control, reset, setValue, watch, handleSubmit } = useFormContext();
  const [activeMaterial, setActiveMaterial] = useState<any>({
    action: null,
    index: null,
    item: null,
  });
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const navigate = useNavigate();
  const siteIdWatch = watch("siteId");
  const [materialCategoryOptions, setMaterialCategoryOptions] = useState([]);
  const viewChange = () => {
    setScreenSize(window.innerWidth);
    if (window.innerWidth < 990) {
      setMobileView(true);
    } else {
      setMobileView(false);
      setSm(false);
    }
  };

  const { fields, append, remove, update }: any = useFieldArray({
    control,
    name: "items",
  });
  const configColumns = (cols: any) => {
    const configredColumns: any = [];
    cols.forEach((col: any) => {
      const { key } = col;
      configredColumns.push(col);
    });
    return configredColumns;
  };
  const [columns, setColumns] = useState<TableColumnsType<any>>([
    {
      title: "Category",
      dataIndex: "materialCategoryName",
      key: "materialCategoryName",
      width: 250,
    },
    {
      title: "Material Name",
      dataIndex: "materialLabel",
      key: "materialLabel",
      width: 220,
      fixed: "left",
    },
    {
      title: "Material Usage",
      dataIndex: "materialUsage",
      key: "materialUsage",
      width: 220,
      fixed: "left",
    },
    {
      title: "QTY",
      dataIndex: "quantity",
      key: "quantity",
      width: 150,
      render: (text, record) => {
        return (
          <span>
            {text} {record?.uomLabel}
          </span>
        );
      },
    },
    {
      title: "Installation Required",
      dataIndex: "installationRequired",
      key: "installationRequired",
      width: 150,
      render: (value: any) => (value ? "Yes" : "No"),
    },
    {
      title: "Tower / Block",
      dataIndex: "towerBlockVillaLabel",
      key: "towerBlockVillaLabel",
      width: 150,
      render: (text: any) => text || "-",
    },
    {
      title: "Floor",
      dataIndex: "floorLabel",
      key: "floorLabel",
      width: 100,
      render: (text: any) => text || "-",
    },
    {
      title: "Flat",
      dataIndex: "flatLabel",
      key: "flatLabel",
      width: 100,
      render: (text: any) => text || "-",
    },
    {
      title: "NEED BY DATE",
      dataIndex: "needByDate",
      key: "needByDate",
      width: 150,
      render: (text, record) => {
        return <span>{dayjs(text).format("DD-MM-YYYY")}</span>;
      },
    },
    {
      title: "Action",
      key: "operation",
      fixed: "right",
      width: 150,
      render: (text, record, index) => {
        const absoluteIndex = (currentPage - 1) * pageSize + index;
        return (
          <>
            <Tooltip title="Edit">
              <Button
                size="sm"
                color=""
                onClick={() => {
                  setActiveMaterial({
                    action: "edit",
                    index: absoluteIndex,
                    item: record,
                  });
                }}
              >
                <Icon name="edit" />
              </Button>
            </Tooltip>
            <Tooltip title="Delete">
              <Button size="sm" color="" onClick={() => remove(absoluteIndex)}>
                <Icon name="trash" />
              </Button>
            </Tooltip>
            <Tooltip title="Copy">
              <Button
                size="sm"
                color=""
                onClick={() => {
                  setActiveMaterial({
                    action: "edit",
                    index: absoluteIndex,
                    item: { ...record, id: nanoid(), needByDate: null },
                  });
                }}
              >
                <Icon name="copy" />
              </Button>
            </Tooltip>
          </>
        );
      },
    },
  ]);

  const fetchCategorys = async () => {
    try {
      const { data, status } = await supplierApis.fetchSupplierCategory();
      if (status) {
        const categoryOption = data.map((item: any) => ({
          label: item.category,
          value: item.id.toString(),
        }));
        setMaterialCategoryOptions(categoryOption);
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchCategorys();
    viewChange();
    window.addEventListener("load", viewChange);
    window.addEventListener("resize", viewChange);
    const headerClick = () => setSm(false);
    document
      .getElementsByClassName("nk-header")[0]
      ?.addEventListener("click", headerClick);

    return () => {
      window.removeEventListener("resize", viewChange);
      window.removeEventListener("load", viewChange);
      document
        .getElementsByClassName("nk-header")[0]
        ?.removeEventListener("click", headerClick);
    };
  }, []);
  const addNewRow = () => {
    setActiveMaterial({
      action: "add",
      index: null,
      item: null,
    });
  };
  const saveDraft = () => {};
  return (
    <>
      <h6>Tender For Material</h6>
      <Block className="mt-3">
        <form className="form-validate" onSubmit={handleSubmit(() => {})}>
          <div className="d-flex justify-content-end" style={{ gap: "8px" }}>
            {fields.length > 0 && (
              <Button
                color="link"
                size="sm"
                style={{ color: "#e85347", textDecoration: "none" }}
                onClick={() => {
                  Swal.fire({
                    title: "Are you sure?",
                    text: "This will remove all material lines.",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#d33",
                    cancelButtonColor: "#3085d6",
                    confirmButtonText: "Yes, clear all!",
                  }).then((result) => {
                    if (result.isConfirmed) {
                      remove();
                    }
                  });
                }}
              >
                <Icon name="trash" /> &nbsp; Clear All
              </Button>
            )}
            <BulkMaterialUpload
              append={(data: any) => {
                append(data);
              }}
              tenderFor={watch("tenderFor")}
              siteId={siteIdWatch}
            />
          </div>
          <Row style={{ marginTop: "15px" }}>
            <div className="table-responsive">
              <div style={{ width: screenSize - 120 + "px", margin: "auto" }}>
                {columns && (
                  <Table
                    columns={configColumns(columns)}
                    dataSource={fields}
                    scroll={{ x: "max-content" }} // Adjust this as necessary
                    expandable={{
                      expandedRowRender: (record: any) => (
                        <div className="expandableBody">
                          <div style={{ flex: 1, textAlign: "left" }}>
                            <p style={{ margin: 0 }}>{record.description}</p>
                            {record.file && record.file[0] && (
                              <div>
                                <PaperClipOutlined /> &nbsp;
                                <a
                                  href={URL.createObjectURL(record.file[0])}
                                  download={record.file[0]?.name}
                                >
                                  {record.file[0]?.name}
                                </a>
                              </div>
                            )}
                          </div>
                        </div>
                      ),
                    }}
                    locale={{
                      emptyText: (
                        <span
                          style={{
                            height: "300px",
                            color: "#333",
                            fontSize: "16px",
                          }}
                        >
                          Please click on "Add New Item" to add material lines.
                        </span>
                      ),
                    }}
                    bordered
                    size="small"
                    pagination={{
                      current: currentPage,
                      pageSize: pageSize,
                      showSizeChanger: true,
                      pageSizeOptions: ["10", "20", "50", "100"],
                      showTotal: (total, range) =>
                        `${range[0]}-${range[1]} of ${total} items`,
                      onChange: (page, size) => {
                        setCurrentPage(page);
                        setPageSize(size);
                      },
                    }}
                  />
                )}
              </div>
              <Row
                style={{
                  margin: "20px",
                }}
              >
                <Col className="justify-between">
                  <a onClick={addNewRow} className="addNewItem">
                    <Icon name="plus-round" />
                    <span>Add New Item</span>
                  </a>
                </Col>
              </Row>
            </div>
          </Row>
          {/* </div> */}

          <div className="actions clearfix">
            <ul>
              <li>
                <Button
                  title={fields.length === 0 ? "Please add materials" : ""}
                  disabled={
                    fields?.length == 0 ||
                    fields?.find((line: any) => line?.errorFlag)?.errorFlag
                  }
                  color="primary"
                  type="submit"
                  onClick={() => {
                    next();
                  }}
                >
                  Next
                </Button>
              </li>
              <li>
                <Button
                  type="button"
                  color="primary"
                  onClick={prev}
                  className="btn-dim btn btn-secondary"
                >
                  Previous
                </Button>
              </li>
              {/* {fields.length > 0 && (
                <li>
                  {disableSubmit ? (
                    <Button color="secondary" type="button">
                      <Spinner size="sm" color="light" />
                    </Button>
                  ) : (
                    <Button
                      color="secondary"
                      disabled={
                        fields?.find((line: any) => line?.errorFlag)?.errorFlag
                      }
                      onClick={
                        () => saveDraft()
                        //   previousFormDate,
                        //   previousFormDate?.type == "draft",
                        //   navigate,
                        //   setDisableSubmit
                      }
                      className="btn btn-secondary"
                    >
                      Save as Draft
                    </Button>
                  )}
                </li>
              )} */}
            </ul>
          </div>
        </form>
      </Block>
      {activeMaterial?.action && (
        <MaterialModal
          modal={!!activeMaterial.action}
          closeModal={() => {
            setActiveMaterial({
              action: null,
              index: null,
              item: null,
            });
          }}
          materialCategoryOptions={materialCategoryOptions}
          append={(data: any) => {
            for (let i = 0; i < fields.length; i++) {
              let item: any = fields[i];
              if (
                normalize(item.materialName) ===
                  normalize(data.materialName) &&
                normalize(item.materialUsage) ===
                  normalize(data.materialUsage)
              ) {
                Swal.fire({
                  icon: "error",
                  title: "Duplicate Material",
                  text: "A material with the same name and usage already exists.",
                });
                return;
              }
            }

            append(data);
          }}
          update={(index: any, data: any) => {
            const duplicate = fields.find(
              (item: any, idx: number) =>
                idx !== index &&
                normalize(item.materialName) ===
                  normalize(data.materialName) &&
                normalize(item.materialUsage) ===
                  normalize(data.materialUsage)
            );

            if (duplicate) {
              Swal.fire({
                icon: "error",
                title: "Duplicate Material",
                text: "A material with the same name and usage already exists.",
              });
              return;
            }
            update(index, { ...data, errorFlag: false, errorMessage: [] });
          }}
          formData={activeMaterial}
          materialsList={fields?.map((row: any) =>
            row?.materialName?.toString()
          )}
          siteId={siteIdWatch}
          deliveryAddressType={watch("deliveryAddressType")}
        />
      )}
    </>
  );
};

export default TenderForMaterialMain;
